import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { usePreDepositModals } from '../../../hooks/usePreDepositModals'
import { StyledWrapper } from './style'
import { WithdrawDetails } from '../../molecules/WithdrawDetails'
import { BankAccountWithdrawForm } from '../../molecules/BankAccountWithdrawForm'
import { KycStatus, PaymentTypes } from '../../../utils/constants'
import { getPlayerBankAccounts } from '../../../utils/getPlayerBankAccounts'
import { useLoading } from '../../../hooks/useLoading'
import { BankAccountWithdrawVerification } from '../../molecules/BankAccountWithdrawVerification'

export const BankAccountWithdrawFlow = ({ method, onClose }) => {
  const [bankAccounts, setBankAccounts] = useState([])
  const { openAddBankAccountModal, openLivenessModal } = usePreDepositModals()
  const [doNotHaveBankAccount, setDoNotHaveBankAccount] = useState(null)
  const { isLoading, startLoading, stopLoading } = useLoading()

  const getInitialData = async () => {
    startLoading()

    const {
      activeAccounts,
      inactiveAccounts,
      DO_NOT_HAVE_BANK_ACCOUNT,
      HAVE_BANK_ACCOUNT_PENDING_VALIDATION,
      HAVE_BANK_ACCOUNT_PENDING_LIVENESS,
    } = await getPlayerBankAccounts()

    stopLoading()

    if (DO_NOT_HAVE_BANK_ACCOUNT) {
      openAddBankAccountModal(onClose)
      setDoNotHaveBankAccount(false)
      return
    }

    if (HAVE_BANK_ACCOUNT_PENDING_VALIDATION) {
      setDoNotHaveBankAccount(true)
      return
    }

    setDoNotHaveBankAccount(false)

    if (HAVE_BANK_ACCOUNT_PENDING_LIVENESS) {
      const waitingLivenessAccounts = inactiveAccounts.filter(
        ({ status }) => status === KycStatus.WAITING_LIVENESS
      )

      openLivenessModal(
        waitingLivenessAccounts[0],
        onClose,
        onClose,
        PaymentTypes.WITHDRAW
      )
      return
    }

    setBankAccounts(activeAccounts)
  }

  useEffect(() => {
    getInitialData()
  }, [])

  if (!method || isLoading || doNotHaveBankAccount === null) return null

  if (doNotHaveBankAccount) {
    return (
      <StyledWrapper>
        <BankAccountWithdrawVerification onClose={onClose} />
      </StyledWrapper>
    )
  }

  return (
    <StyledWrapper>
      <WithdrawDetails
        minimumAmount={method?.minimumAmount}
        maximumAmount={method?.maximumAmount}
        infoText={method?.customerInformation?.[0]?.info}
      />
      <BankAccountWithdrawForm
        method={method}
        minimumAmount={method?.minimumAmount}
        maximumAmount={method?.maximumAmount}
        bankAccounts={bankAccounts}
      />
    </StyledWrapper>
  )
}

BankAccountWithdrawFlow.propTypes = {
  method: PropTypes.string,
  onClose: PropTypes.func,
}
